const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleLnbHandler(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h18v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 84",
    transform: "translate(1 1)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0h16"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 85",
    transform: "translate(1 8)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0h16"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 86",
    transform: "translate(1 15)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeWidth: 2,
      fill: "none"
    },
    d: "M0 0h16"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleLnbHandler);
export default __webpack_public_path__ + "static/media/toggle-lnb-handler.0d9730257fd8ee35239547f140ef9134.svg";
export { ForwardRef as ReactComponent };